// extracted by mini-css-extract-plugin
export default {"buttonDefault":"topicsNav_buttonDefault__lPSrU","buttonSelected":"topicsNav_buttonSelected__eYmIb"};